import MenuTab from './MenuTab'
import MenuTabItem from './MenuTabItem'
import MenuTabPane from './MenuTabPane'
export { MenuTab, MenuTabItem, MenuTabPane }
export default MenuTab
